// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.language-toggle {
  background-color: transparent;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 4px;
  padding: 0.5rem 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: white;
  font-size: 0.9rem;
  font-weight: 500;
}

.language-toggle:hover {
  background-color: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.5);
}

.language-option {
  color: rgba(255, 255, 255, 0.6);
  transition: color 0.3s ease;
}

.language-option.active {
  color: #4ecca3;
  font-weight: 600;
}

.language-separator {
  color: rgba(255, 255, 255, 0.3);
}

@media (max-width: 768px) {
  .language-toggle {
    padding: 0.4rem 0.8rem;
    font-size: 0.85rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/LanguageToggle.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,0CAA0C;EAC1C,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,sCAAsC;AACxC;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE;IACE,sBAAsB;IACtB,kBAAkB;EACpB;AACF","sourcesContent":[".language-toggle {\n  background-color: transparent;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  border-radius: 4px;\n  padding: 0.5rem 1rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: white;\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.language-toggle:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n  border-color: rgba(255, 255, 255, 0.5);\n}\n\n.language-option {\n  color: rgba(255, 255, 255, 0.6);\n  transition: color 0.3s ease;\n}\n\n.language-option.active {\n  color: #4ecca3;\n  font-weight: 600;\n}\n\n.language-separator {\n  color: rgba(255, 255, 255, 0.3);\n}\n\n@media (max-width: 768px) {\n  .language-toggle {\n    padding: 0.4rem 0.8rem;\n    font-size: 0.85rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
